import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ActivatedRouteSnapshot, CanActivate, ParamMap, Router, RouterStateSnapshot} from '@angular/router';
import {catchError, map, switchMap, take, tap} from 'rxjs/operators';
import {AuthState, LifeisLifeWsAuth, Role, UserAuthService} from '@lifeislife/lifeislife-domain';
import {UserLoggedInRouterGuard} from './user-logged-in.guard';


@Injectable()
export class UserLoggedInRouterGuardBrowser implements CanActivate, UserLoggedInRouterGuard {

  constructor(private userAuthService: UserAuthService,
              private router: Router) {
  }

  canActivate(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.isUserLoggedIn$(activatedRoute, state);
  }

  private isUserLoggedIn$(activatedRoute: ActivatedRouteSnapshot, routerState?: RouterStateSnapshot): Observable<boolean> {
    const loginRedirectParams = {};
    if (routerState) {
      loginRedirectParams['redirectUrl'] = routerState.url;
    }
    const queryParams = activatedRoute.queryParamMap;

    return this.userAuthService.restoreAuthIfRequired$(queryParams, Role.CUSTOMER).pipe(
      map(a => this.checkAuthenticatedGrantedOrRedirect(a, activatedRoute, loginRedirectParams)),
      catchError(e => {
        console.warn(`Route activation denied:`);
        console.warn(e);
        this.redirectOnAccessDenied(null, loginRedirectParams, activatedRoute, e);
        return of(false);
      }),
      tap(granted => this.checkRedirectWhenGranted(granted, queryParams, activatedRoute)),
    );
  }

  private checkAuthenticatedGrantedOrRedirect(state: AuthState,
                                              activatedRoute: ActivatedRouteSnapshot, loginParam: any) {

    let accessGranted = state != null;
    if (state != null) {
      try {
        this.checkAccessGrantedOrThrow(activatedRoute, state.user, state.roles, state.wsAuth);
      } catch (e) {
        accessGranted = false;
        console.warn(`Route access(${activatedRoute.url}) denied: ${e}`);
      }
    }
    if (!accessGranted) {
      const wsAuth = state == null ? null : state.wsAuth;
      this.redirectOnAccessDenied(wsAuth, loginParam, activatedRoute);
    }

    return accessGranted;
  }


  private checkAccessGrantedOrThrow(activatedRoute, user, roles: Role[], auth) {
    const requiredRoles = [Role.INVITEE, Role.CUSTOMER];

    if (auth == null) {
      return false;
    }
    const rolesGranted = requiredRoles.length === 0 || requiredRoles.find(requiredRole => roles.includes(requiredRole)) != null;
    if (!rolesGranted) {
      const message = `User roles does not include any of ${requiredRoles}`;
      console.warn(message);
      // Ignore: handled on customer selection: show 'Not our customer yet' message.
      // this.userAuthService.deauthenticate(message);
      // throw new Error(message);
      return true;
    }
    // TODO: permissions
    return true;
  }

  private redirectOnAccessDenied(auth: LifeisLifeWsAuth, loginParam: any, activatedRoute: ActivatedRouteSnapshot, error?: any) {
    // Skip redirect params: it needs proper parsing
    // 202010 warning: resored despite the above message
    this.router.navigate(['/login'], {
      queryParamsHandling: 'merge',
      queryParams: loginParam,
    });
  }

  private checkRedirectWhenGranted(granted: boolean, queryParams: ParamMap, activatedRoute: ActivatedRouteSnapshot) {
    if (!granted) {
      return;
    }
    // // Clean auth code params
    // const authCodeParam = queryParams.get('authCode');
    // const authErrorParam = queryParams.get('authError');
    // if (authCodeParam || authErrorParam) {
    //   if (activatedRoute) {
    //     this.router.navigate(['/products'], {
    //       queryParams: {
    //         authCode: null,
    //         authError: null,
    //       },
    //       queryParamsHandling: 'merge',
    //     });
    //   }
    // }
  }
}
